<template>
  <a-modal
    :title="title"
    :width="800"
    :visible="visible"
    :confirmLoading="confirmLoading"
    @ok="handleOk"
    @cancel="handleCancel"
    :cancelText="$t('antd.table.close')"
    wrapClassName="ant-modal-cust-warp"
    style="top:5%;height: 85%;overflow-y: hidden">

    <a-spin :spinning="confirmLoading">
      <a-form-model ref="form"  v-bind="layout"  :model="model" :rules="validatorRules">
        <a-form-model-item :label="$t('dashboard.analysis.aisleName')" required prop="aisleName">
          <a-input v-model="model.aisleName" :placeholder="$t('dashboard.analysis.plAisleName')"/>
        </a-form-model-item>
        <a-form-model-item :label="$t('dashboard.analysis.aisleCode')" required prop="aisleCode">
          <a-input v-model="model.aisleCode" :placeholder="$t('dashboard.analysis.plAisleCode')"/>
        </a-form-model-item>
      </a-form-model>
    </a-spin>
  </a-modal>
</template>

<script>
  import { aisleCreate, aisleUpdate } from 'api/app'
  export default {
    name: "AisleCreate",
    data () {
      return {
        title:"操作",
        visible: false,
        model: {},
        layout: {
          labelCol: { span: 3 },
          wrapperCol: { span: 14 },
        },
        confirmLoading: false,
        validatorRules:{
          aisleCode: [
            { required: true, message: this.$t('dashboard.analysis.plAisleCode') },

          ],
          aisleName: [
            { required: true, message: this.$t('dashboard.analysis.plAisleName')},
          ]
        },
      }
    },
    created () {
      //备份model原始值
      this.modelDefault = JSON.parse(JSON.stringify(this.model));
    },
    methods: {
      add (options) {
        this.edit({...this.modelDefault, ...options});
      },
      edit (record) {
        this.model = Object.assign({}, record);
        this.visible = true;
      },
      close () {
        this.$refs.form.clearValidate();
        this.$emit('close');
        this.visible = false;
      },
      handleOk () {
        const that = this;
        // 触发表单验证
        this.$refs.form.validate(valid => {
          if (valid) {
            that.confirmLoading = true;
            let obj;
            if(!this.model.id){
              obj=aisleCreate(this.model);
            }else{
              obj=aisleUpdate(this.model);
            }
            obj.then((res)=>{
              if(res.code == '200'){
                that.$message.success(res.msg);
                that.$emit('ok');
              }else{
                that.$message.warning(res.msg);
              }
            }).finally(() => {
              that.confirmLoading = false;
              that.close();
            })
          }else{
            return false;
          }
        })
      },
      handleCancel () {
        this.close()
      },
      validateRoleCode(value, callback){
        if(/[\u4E00-\u9FA5]/g.test(value)){
          callback("角色编码不可输入汉字!");
        }else{
          // let params = {
          //   tableName: "sys_role",
          //   fieldName: "role_code",
          //   fieldVal: value,
          //   dataId: this.model.id,
          // };
          // duplicateCheck(params).then((res)=>{
          //   if(res.success){
          //     callback();
          //   }else{
          //     callback(res.message);
          //   }
          // });
        }
      }
    }
  }
</script>

<style scoped>

</style>
